import React from "react";
import Typography from "@components/Typography";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { Link, useHistory } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import {
  getBalanceRateInQuote,
  getCurrencyMeta,
  getIconPath,
  getIrtMarketKey,
  getUnitPriceFromStats,
} from "@core/utils/getCurrencyMeta";
import clsx from "clsx";
import NumberFormat from "react-number-format";
import CustomTableWithPagination from "@components/CustomTableWithPagination";
import { useTheme } from "@material-ui/core";

const CoinInfo = ({
  data,
  stats = [],
  assets = [],
  OverrideTableOption,
  type = "default",
  className
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const TableOption = [
    {
      name: "wallet",
      title: __t("wallet"),
      width: "15%",
      align: "center",
      date: true,

      render: record => {
        const currentCurrency = getCurrencyMeta(record.currencyName);
        const CurrencyIcon = currentCurrency.Icon;

        return (
          <div className={classes.coinLogoAndText}>
            {CurrencyIcon ? (
              <CurrencyIcon
                style={{
                  color: currentCurrency.color,
                  marginLeft: "5px",
                }}
                className={classes.coinLogo}
              />
            ) : (
              <img
                src={getIconPath(currentCurrency.code)}
                alt={currentCurrency.code}
                className={classes.coinLogo}
                style={{ marginLeft: "5px" }}
              />
            )}
            <Typography variant={"xs"} isBold className={classes.currencyName}>
              {currentCurrency.name}
            </Typography>
            <Typography className={classes.coinTitle}>{`(${currentCurrency.unit})`}</Typography>
          </div>
        );
      }
    },

    {
      render: record => {
        return record.currencyName === "IRT" ? (
          <NumberFormat
            value={record.totalBalance}
            displayType={"text"}
            thousandSeparator={true}
          />
        ) : (
          record.totalBalance
        );
      },
      title: __t("amount"),
      width: "10%"
    },

    {
      render: record => {
        const currencyRate = getBalanceRateInQuote(
          record?.currencyName,
          stats,
          "IRT"
        );
        const averageIrtAmount =
          typeof record.totalBalance === "number" &&
          record.totalBalance !== 0 &&
          currencyRate
            ? record.totalBalance * currencyRate
            : "-";
        const percent =
          record.currencyName !== "LTC"
            ? typeof averageIrtAmount === "number" &&
              (100 * (averageIrtAmount / assets)).toFixed(2)
            : typeof averageIrtAmount === "number" &&
              (100 * (averageIrtAmount / assets)).toFixed(6);
        return <Typography isBold>{percent ? `${percent} %` : `0`}</Typography>;
      },
      title: __t("Assests Percent"),
      width: "10%"
    },

    {
      render: record => {
        return record.currencyName === "IRT" ? (
          <NumberFormat
            value={record.blockedBalance}
            displayType={"text"}
            thousandSeparator={true}
          />
        ) : (
          record.blockedBalance
        );
      },
      title: __t("blocked"),
      width: "10%",
      align: "center"
    },

    {
      render: record => {
        return record.currencyName === "IRT" ? (
          <NumberFormat
            value={record.availableBalance}
            displayType={"text"}
            thousandSeparator={true}
          />
        ) : (
          record.availableBalance
        );
      },
      title: __t("available"),
      width: "10%",
      align: "center"
    },

    {
      render: record => {
        const irtMarketKey = getIrtMarketKey(record.currencyName);
        const unitPrice = getUnitPriceFromStats(stats, irtMarketKey, null);

        return (
          <div>
            {unitPrice != null ? (
              <NumberFormat
                value={(unitPrice * record?.totalBalance).toFixed(0)}
                displayType={"text"}
                thousandSeparator={true}
              ></NumberFormat>
            ) : (
              <span>-</span>
            )}
          </div>
        );
      },
      title: __t("market value (toman)"),
      width: "20%",
      align: "center"
    },

    {
      render: record => {
        return (
          <div className={classes.wrapperLastCol}>
            <Tooltip arrow title={__t("deposit")} placement="top-start">
              <div className={classes.inlineBlock}>
                <Link to={`/wallets/${record?.currencyName}/deposit`}>
                  <i className={clsx(classes.plusBtn, "icon-plus")} />
                </Link>
              </div>
            </Tooltip>
            <Tooltip arrow title={__t("withdraw")} placement="top-start">
              <div className={classes.inlineBlock}>
                <Link to={`/wallets/${record?.currencyName}/withdraw`}>
                  <i
                    className={clsx(
                      classes.cashOutBtn,
                      "icon-cash-out-request"
                    )}
                  />
                </Link>
              </div>
            </Tooltip>
            <div style={{ width: "20px", height: "20px" }}>
              {record?.currencyName !== "IRT" && (
                <Tooltip arrow title={__t("Market")} placement="top-start">
                  <div className={classes.inlineBlock}>
                    <Link to={`/market/${record?.currencyName}-IRT`}>
                      <i className={clsx(classes.bagBtn, "icon-bag")} />
                    </Link>
                  </div>
                </Tooltip>
              )}
            </div>
          </div>
        );
      },
      name: "",
      width: "15%",
      align: "center",
      lastFixed: window.innerWidth > theme.breakpoints.values.sm ? false : true
    }
  ];

  const history = useHistory();

  const handleClick = event => {
    if (event.target.nodeName !== "I") {
      const tr = event.target.closest("tr");
      const coinName = tr.id;
      history.push(`/wallets/${coinName && coinName}/deposit`);
    }
  };
  return (
    <>
      <CustomTableWithPagination
        TableOption={!!OverrideTableOption ? OverrideTableOption : TableOption}
        data={data}
        is_fetch={true}
        className={className}
        handleClick={handleClick}
        pagination={true}
        type={type}
        cursorType="pointer"
      />
    </>
  );
};

export default CoinInfo;
